import moment from 'moment-timezone';
import { ApiConfig } from "../../config/ApiConfig";
moment.tz.setDefault(ApiConfig.timeZone);

export default moment;
